var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "upload",
          attrs: {
            model: _vm.uploadForm,
            "label-width": "80px",
            "label-position": "left",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "files", label: "Criteria" } },
            [
              _c("el-input", {
                staticStyle: { width: "100" },
                attrs: { placeholder: "", disabled: "" },
                model: {
                  value: _vm.factsInfo.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.factsInfo, "name", $$v)
                  },
                  expression: "factsInfo.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "docComments", label: "Description" } },
            [
              _c("el-input", {
                staticStyle: { width: "100%" },
                attrs: { placeholder: "", disabled: "" },
                model: {
                  value: _vm.factsInfo.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.factsInfo, "description", $$v)
                  },
                  expression: "factsInfo.description",
                },
              }),
            ],
            1
          ),
          _c("el-input", {
            staticStyle: { width: "100%" },
            attrs: {
              type: "textarea",
              maxlength: "1000",
              "show-word-limit": "",
              placeholder: "请输入内容",
              autosize: { minRows: 4 },
            },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
          _c(
            "el-row",
            {
              staticClass: "row-bg",
              staticStyle: { "margin-top": "15px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addFacts } },
                [_vm._v("保存")]
              ),
              _c("el-button", { on: { click: _vm.closeFacts } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }